<template>
  <div class="reissue-password">
    <!-- ↓↓ パスワード再発行 ↓↓ -->
    <div v-if="pageType === 'default'">
      <el-row>
        <h1>パスワード再発行</h1>
      </el-row>
      <div class="center">
        <div>
          <p>
            登録メールアドレスを入力してください。<br class="sp-only">パスワード再設定用URLを送信します。
          </p>
        </div>
        <el-input type="text" placeholder="abcdefg@gmail.com" v-model="email" style="max-width: 700px;">
          <template slot="prepend">登録メールアドレス</template>
        </el-input>
        <ValidationErrorMessages :errorMessageList="validationErrorData.email" />
      </div>
      <el-row>
        <el-col class="button-cover">
          <el-button @click="sendToken" type="primary">送信</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- ↑↑ パスワード再発行 ↑↑ -->

    <!-- ↓↓ 暗証番号の確認 ↓↓ -->
    <div v-else-if="pageType === 'confirm'">
      <el-row type="flex" justify="center">
        <el-col>
          <h1>暗証番号の確認</h1>
          <p>登録済みメールアドレスに認証用のメールを送信しました。<br>メール内に記載されている暗証番号を入力してください。</p>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="6">
          <el-input type="text" placeholder="1234567" v-model="token">
            <template slot="prepend">暗証番号</template>
          </el-input>
          <ValidationErrorMessages :errorMessageList="validationErrorData.token" />
        </el-col>
      </el-row>
      <el-row>
        <el-col class="button-cover">
          <el-button @click="confirmToken" type="primary">認証</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- ↑↑ 暗証番号の確認 ↑↑ -->

    <!-- ↓↓ パスワードの更新 ↓↓ -->
    <div v-else-if="pageType === 'reissue'">
      <el-row type="flex" justify="center">
        <h1>パスワードの更新</h1>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <el-input type="password" placeholder="abcdefg12345678" v-model="newPassword">
            <template slot="prepend">新しいパスワード</template>
          </el-input>
          <ValidationErrorMessages :errorMessageList="validationErrorData.newPassword" />
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <el-input type="password" placeholder="abcdefg12345678" v-model="newPasswordForConfirmation">
            <template slot="prepend">新しいパスワード（確認用）</template>
          </el-input>
          <ValidationErrorMessages :errorMessageList="validationErrorData.newPasswordForConfirmation" />
        </el-col>
      </el-row>
      <el-row>
        <el-col class="button-cover">
          <el-button @click="reissuePassword" type="primary">変更</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- ↑↑ パスワードの更新 ↑↑ -->

    <!-- ↓↓ パスワードの更新完了 ↓↓ -->
    <div v-else-if="pageType === 'complete'">
      <el-row type="flex" justify="center">
        <h1>パスワードの更新完了</h1>
      </el-row>
      <el-row>
        <el-col class="button-cover">
          <router-link to="/login">
            <el-button type="primary">ログイン画面へ</el-button>
          </router-link>
        </el-col>
      </el-row>
    </div>
    <!-- ↑↑ パスワードの更新完了 ↑↑ -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidationErrorMessages from "@/components/Ui/ValidationErrorMessages.vue";

export default {
  components: {
    ValidationErrorMessages,
  },
  data() {
    return {
      pageType: "default",
      email: "",
      token: "",
      token2: "",
      newPassword: "",
      newPasswordForConfirmation: "",
      validationErrorData: {
        email: [],
        token: [],
        newPassword: [],
        newPasswordForConfirmation: [],
      },
    };
  },
  computed: {
    ...mapGetters(["rt", "apiErrorMessage"]),
  },
  methods: {
    resetValidationErrorData() {
      this.validationErrorData = {
        email: [],
        token: [],
        newPassword: [],
        newPasswordForConfirmation: [],
      };
    },
    sendToken() {
      let params = new URLSearchParams();
      params.append("email", this.email);
      this.$axios
        .post(`${this.rt}/l/api/auth/send-reissue-password-token`, params)
        .then((response) => {
          console.log(response);

          // 
          if (response.data.status === 200) {
            this.resetValidationErrorData();
            this.pageType = "confirm";
          } else if (response.data.status === 400) {
            this.validationErrorData = {
              ...this.validationErrorData,
              ...response.data.validationErrorData,
            };
          } else if (response.data.status === 401) {
            alert(response.data.message);
          } else if (response.data.status === 423) {
            alert(response.data.message);
          } else {
            alert(this.apiErrorMessage);
          }

          // 
          return;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    confirmToken() {
      let params = new URLSearchParams();
      params.append("email", this.email);
      params.append("token", this.token);
      this.$axios
        .post(`${this.rt}/l/api/auth/confirm-reissue-password-token`, params)
        .then((response) => {
          console.log(response);

          // 
          if (response.data.status === 200) {
            this.resetValidationErrorData();
            this.pageType = "reissue";
          } else if (response.data.status === 400) {
            this.validationErrorData = {
              ...this.validationErrorData,
              ...response.data.validationErrorData,
            };
          } else if (response.data.status === 401) {
            alert(response.data.message);
          } else if (response.data.status === 423) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
          }

          // 
          return;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    reissuePassword() {
      let params = new URLSearchParams();
      params.append("email", this.email);
      params.append("new_password", this.newPassword);
      params.append(
        "new_password_for_confirmation",
        this.newPasswordForConfirmation
      );
      this.$axios
        .post(`${this.rt}/l/api/auth/reissue-password`, params)
        .then((response) => {
          console.log(response);

          // 
          if (response.data.status === 200) {
            this.resetValidationErrorData();
            this.pageType = "complete";
          } else if (response.data.status === 400) {
            this.validationErrorData = {
              ...this.validationErrorData,
              ...response.data.validationErrorData,
            };
          } else if (response.data.status === 401) {
            alert(response.data.message);
          } else {
            alert(this.apiErrorMessage);
          }

          // 
          return;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
h1,
p {
  text-align: center;
}

.el-col.button-cover {
  text-align: center;
}

.desc {
  color: #999;
}

a.here {
  text-decoration: underline;
}

.center {
  display: flex;
  flex-direction: column;
  align-items: center;

  div {
    max-width: 1100px;
    width: 80%;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }

}
</style>
